"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ensure = void 0;
function ensure(obj, keys) {
    return keys.every((key) => obj[key] !== undefined && obj[key] !== null);
}
exports.ensure = ensure;
